import React from 'react';
import { get } from 'lodash';

import ImageSuccess from 'assets/images/push-up-icons/success.svg';
import {
  StyledVerticalDrawer,
  StyledButton,
  PushUpBodyDiv
} from 'components/Styled';

const PushUpDrawer = props => {
  const { title, subTitle, btnTitle, visible, onClose, btnClick } = props;
  const status = get(props, 'status') || 'success';

  let icon;
  switch (status) {
    case 'success':
      icon = ImageSuccess;
      break;
    default:
      icon = ImageSuccess;
      break;
  }

  return (
    <div>
      <StyledVerticalDrawer
        className={props.containerClasses || ''}
        placement="bottom"
        onClose={onClose}
        visible={visible}
        height="100%"
        closable={true}>
        <PushUpBodyDiv className="text-center">
          <img className={props.imageClasses || ''} src={icon} alt="" />
          <h1 className="secondary-color">{title}</h1>
          <span className="subTitle buttonTheme-color">{subTitle}</span>
          <div className="actions-btn-group text-center">
            <StyledButton type="primary" shadow="true" onClick={btnClick}>
              {btnTitle}
            </StyledButton>
          </div>
        </PushUpBodyDiv>
      </StyledVerticalDrawer>
    </div>
  );
};

export default PushUpDrawer;
